/**
 * 内示正答率関連の定数
 */

/**
 * 内示正答率の閾値
 * @description 色分け表示に使用する閾値
 */
export const ACCURACY_THRESHOLDS = {
  /** 危険レベル（赤色表示）の閾値 */
  CRITICAL: 90,
  /** 警告レベル（黄色表示）の閾値 */
  WARNING: 95,
} as const;

/**
 * 設定内示正答率の入力範囲
 */
export const SETTING_ACCURACY_RANGE = {
  /** 最小値 */
  MIN: 0,
  /** 最大値 */
  MAX: 200,
} as const;
